import { Entity } from '@bumble/app/__generated__/data-contracts';
import NoData from '@bumble/app/components/NoData';
import { Box } from '@mui/material';
import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { toast } from 'react-toastify';
import { apiError } from '@bumble/app/utils/api-error';

const columns: GridColDef[] = [
  {
    field: 'entity_name',
    headerName: 'Entity name',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'entity_id',
    headerName: 'Entity ID',
    width: 200,
    disableColumnMenu: true,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 200,
    disableColumnMenu: true,
  },
];

const columnVisible = {
  entity_name: true,
  entity_id: true,
  description: true,
};

interface ContactDetailsProps {
  data: Entity[];
  contactId: string | undefined;
  refetchData: () => void
}

export const ContactDetails = ({ data, contactId, refetchData }: ContactDetailsProps) => {
  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
  const api = useApi();

  const unassignEntity = useMutation(api.contactUnassignEntityApiV1ContactUnassignEntityPost, {
    onSuccess(data) {
      const msg = 'status' in data.data
        ? data.data.status as string
        : `Unassigned entity successfully.`;
      toast.success(msg);
      refetchData();
    },
    onError: apiError
  });

  const handleSelectionChange = (newSelection: GridRowSelectionModel) => {
    setRowSelectionModel(newSelection);
  };

  const handleSubmit = () => {
    if (contactId && rowSelectionModel && rowSelectionModel.length === 1) {
      unassignEntity.mutate({
        contact_id: contactId,
        entity_name: rowSelectionModel[0].toString()
      });
    }
  };

  if (data === undefined) return <NoData />;

  return (
    <Box>
      <DataTableGrid
        rows={data.map((r, i) => ({ ...r, id: r.entity_name }))}
        columns={columns}
        columnVisibilityModel={columnVisible}
        handleSelectionChange={handleSelectionChange}
        rowSelectionModel={rowSelectionModel}
        itemsSelected={rowSelectionModel.length === 1}
        refreshData={refetchData}
        menuItems={[
          {
            label: 'Unassign Entity',
            icon: <LinkOffOutlinedIcon color="info" fontSize="small" />,
            onClick: handleSubmit,
          },
        ]}
      />
    </Box>
  );
};
